import config from '../config'
import { authRequest } from '../request'

const base = `${config.mainApi}/internal-users`

export type InternalUser = {
  id: number
  userId: number
  userDisplayName: string
  internalUserName: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export type InternalUserInput = Pick<InternalUser, 'userId' | 'internalUserName' | 'isActive'>

export type InternalUserOption = {
  id: number
  displayName: string
}

export type InternalUserFilters = {
  userId?: number
  internalUserName?: string
  isActive?: boolean
}

export const listInternalUsers = (params: InternalUserFilters) =>
  authRequest.get<MISSING_TYPE, InternalUser[]>(base, { params })

export const createInternalUser = (data: InternalUserInput) =>
  authRequest.post<MISSING_TYPE, InternalUser>(base, data)

export const updateInternalUser = (id: number, data: InternalUserInput) =>
  authRequest.put<MISSING_TYPE, InternalUser>(`${base}/${id}`, data)

export const deleteInternalUser = (id: number) => authRequest.delete(`${base}/${id}`)

export const searchInternalUserCandidates = (query: string) =>
  authRequest.get<MISSING_TYPE, InternalUserOption[]>(`${base}/users`, { params: { query } })
